export const emergencyNumbers = [
	{ // Australia
		countryCode: 'AUS',
		callingCode: 61,
		emergencyNumbers: [
			'000',
			'112',
			'132500',
			'1800333000',
			'1800123400',
			'131126',
			'131114'
		]
	},
	{ // The Philippines
		countryCode: 'PHL',
		callingCode: 63,
		emergencyNumbers: [
			'911'
		]
	},
	{ // Great Britain / United Kingdom
		countryCode: 'GBR',
		callingCode: 44,
		emergencyNumbers: [
			'101',
			'105',
			'111',
			'112',
			'119',
			'911',
			'999'
		]
	},
	{ // Italy
		countryCode: 'ITA',
		callingCode: 39,
		emergencyNumbers: [
			'112'
		]
	},
	{ // Germany
		countryCode: 'DEU',
		callingCode: 49,
		emergencyNumbers: [
			'110',
			'112',
			'115',
			'19222',
			'116116',
			'116117'
		]
	},
	{ // France
		countryCode: 'FRA',
		callingCode: 33,
		emergencyNumbers: [
			'15',
			'17',
			'18',
			'112',
			'114',
			'119',
			'196',
			'116000'
		]
	},
	{ // Malaysia
		countryCode: 'MYS',
		callingCode: 60,
		emergencyNumbers: [
			'999'
		]
	},
	{ // Canada / United States / North America
		countryCode: 'USA',
		callingCode: 1,
		emergencyNumbers: [
			'112',
			'211',
			'311',
			'411',
			'511',
			'611',
			'711',
			'811',
			'911'
		]
	},
	{ // United Arab Emirates / UAE
		countryCode: 'ARE',
		callingCode: 971,
		emergencyNumbers: [
			'999',
			'998',
			'997',
			'996',
			'911',
			'922'
		]
	},
	{ // Armenia
		countryCode: 'ARM',
		callingCode: 374,
		emergencyNumbers: [
			'104',
			'108',
			'177',
		]
	},
	{ // Slovakia
		countryCode: 'SVK',
		callingCode: 421,
		emergencyNumbers: [
			'112',
			'150',
			'155',
			'158',
		]
	},
	{ // Romania
		countryCode: 'ROM',
		callingCode: 40,
		emergencyNumbers: [
			'112',
			'911'
		]
	},
	{ // Hungary
		countryCode: 'HUN',
		callingCode: 36,
		emergencyNumbers: [
			'112',
			'104',
			'105',
			'107'
		]
	},
	{ // Lithuania
		countryCode: 'LTU',
		callingCode: 370,
		emergencyNumbers: [
			'112',
			'011',
			'022',
			'033'
		]
	},
	{ // Poland
		countryCode: 'POL',
		callingCode: 48,
		emergencyNumbers: [
			'112',
			'999',
			'998',
			'997',
			'992',
			'986'
		]
	},
	{ // Ukraine
		countryCode: 'UKR',
		callingCode: 380,
		emergencyNumbers: [
			'112',
			'101',
			'102',
			'103',
			'104'
		]
	},
	{ // Albania
		countryCode: 'ALB',
		callingCode: 355,
		emergencyNumbers: [
			'125',
			'126',
			'127',
			'128',
			'129'
		]
	},
	{ // Mali
		countryCode: 'MLI',
		callingCode: 223,
		emergencyNumbers: [
			'17',
			'15',
			'18'
		]
	},
	{ // Nigeria
		countryCode: 'NGA',
		callingCode: 234,
		emergencyNumbers: [
			'112',
			'199'
		]
	},
	{ // Madagascar
		countryCode: 'MDG',
		callingCode: 261,
		emergencyNumbers: [
			'117',
			'118',
			'124'
		]
	},
	{ // Iran
		countryCode: 'IRN',
		callingCode: 98,
		emergencyNumbers: [
			'110',
			'112',
			'115',
			'118',
			'119',
			'123',
			'133',
			'134',
			'141',
			'191',
			'911',
			'51001'
		]
	},
	{ // Iran
		countryCode: 'IRQ',
		callingCode: 964,
		emergencyNumbers: [
			'104',
			'112',
			'115',
			'122',
			'911'
		]
	},
	{ // Thailand
		countryCode: 'THA',
		callingCode: 66,
		emergencyNumbers: [
			'191',
			'1554',
			'199',
			'1860',
			'1195',
			'1669'
		]
	},
	{ // Vietnam
		countryCode: 'VNM',
		callingCode: 84,
		emergencyNumbers: [
			'111',
			'112',
			'113',
			'114',
			'115'
		]
	},
	{ // South Africa
		countryCode: 'ZAF',
		callingCode: 27,
		emergencyNumbers: [
			'10111',
			'10177',
			'107',
			'112'
		]
	},
	{ // Democratic Republic of The Congo
		countryCode: 'COD',
		callingCode: 243,
		emergencyNumbers: [
			'112',
			'118'
		]
	},
	{ // Turkey
		countryCode: 'TUR',
		callingCode: 90,
		emergencyNumbers: [
			'112',
			'114',
			'121',
			'153',
			'183',
			'184',
			'185',
			'186',
			'187',
			'911'
		]
	},
	{ // Central African Republic
		countryCode: 'CAF',
		callingCode: 236,
		emergencyNumbers: [
			'117',
			'118',
			'1220'
		]
	},
	{ // Senegal
		countryCode: 'SEN',
		callingCode: 221,
		emergencyNumbers: [
			'15',
			'17',
			'18',
			'1212'
		]
	},
	{ // Kyrgyzstan
		countryCode: 'KGZ',
		callingCode: 996,
		emergencyNumbers: [
			'101',
			'102',
			'103',
			'112'
		]
	},
	{ // Belgium
		countryCode: 'BEL',
		callingCode: 32,
		emergencyNumbers: [
			'100',
			'101',
			'103',
			'107',
			'110',
			'112'
		]
	},
	{ // Czech Republic
		countryCode: 'CZE',
		callingCode: 420,
		emergencyNumbers: [
			'112',
			'150',
			'155',
			'156',
			'158'
		]
	},
	{ // Greece
		countryCode: 'GRC',
		callingCode: 30,
		emergencyNumbers: [
			'112',
			'100',
			'108',
			'166',
			'199',
			'1056',
			'116000',
			'116111'
		]
	},
	{ // Denmark
		countryCode: 'DNK',
		callingCode: 45,
		emergencyNumbers: [
			'112',
			'114',
			'1813'
		]
	},
	{ // India
		countryCode: 'IND',
		callingCode: 91,
		emergencyNumbers: [
			'100',
			'101',
			'102',
			'104',
			'108',
			'112',
			'181',
			'911',
			'1098',
			'1363',
			'1906'
		]
	},
	{ // Jordan
		countryCode: 'JOR',
		callingCode: 962,
		emergencyNumbers: [
			'112',
			'196',
			'911'
		]
	},
	{ // Kosovo
		countryCode: 'XKX',
		callingCode: 383,
		emergencyNumbers: [
			'112',
			'192',
			'193',
			'194',
			'911'
		]
	},
	{ // Algeria
		countryCode: 'DZA',
		callingCode: 213,
		emergencyNumbers: [
			'14',
			'19',
			'1055',
			'1548',
			'112',
			'911'
		]
	},
	{ // Benin
		countryCode: 'BEN',
		callingCode: 229,
		emergencyNumbers: [
			'117',
			'112',
			'118'
		]
	},
	{ // Ivory Coast
		countryCode: 'CIV',
		callingCode: 225,
		emergencyNumbers: [
			'110',
			'111',
			'170',
			'180',
			'185'
		]
	},
	{ // Azerbaijan
		countryCode: 'AZE',
		callingCode: 994,
		emergencyNumbers: [
			'101',
			'102',
			'103',
			'104',
			'112',
			'199',
			'902'
		]
	},
	{ // Turkmenistan
		countryCode: 'TUK',
		callingCode: 993,
		emergencyNumbers: [
			'01',
			'02',
			'03',
			'04',
			'001',
			'002',
			'003',
			'004'
		]
	},
	{ // Russia - includes Abkhazia (ABK) and Ossetia (OSS)
		countryCode: 'RUS',
		callingCode: 7,
		emergencyNumbers: [
			'112',
			'101',
			'102',
			'103',
			'104'
		]
	},
	{ // Georgia
		countryCode: 'GEO',
		callingCode: 995,
		emergencyNumbers: [
			'112'
		]
	},
	{ // Kenya
		countryCode: 'KEN',
		callingCode: 254,
		emergencyNumbers: [ ]
	},
	{ // Oman
		countryCode: 'OMN',
		callingCode: 968,
		emergencyNumbers: [ ]
	},
	{ // Mexico
		countryCode: 'MEX',
		callingCode: 52,
		emergencyNumbers: [ ]
	},
	{ // Saudi Arabia
		countryCode: 'SAU',
		callingCode: 966,
		emergencyNumbers: [ ]
	},
	{ // Egypt
		countryCode: 'EGY',
		callingCode: 20,
		emergencyNumbers: [ ]
	},
	{ // Portugal
		countryCode: 'PRT',
		callingCode: 351,
		emergencyNumbers: [ ]
	},
	{ // Ethopia
		countryCode: 'ETH',
		callingCode: 251,
		emergencyNumbers: [ ]
	},
	{ // Indonesia
		countryCode: 'IDN',
		callingCode: 62,
		emergencyNumbers: [ ]
	},
	{ // Brazil
		countryCode: 'BRA',
		callingCode: 55,
		emergencyNumbers: [ ]
	},
	{ // Korea
		countryCode: 'KOR',
		callingCode: 82,
		emergencyNumbers: [ ]
	},
	{ // China
		countryCode: 'CHN',
		callingCode: 86,
		emergencyNumbers: [ ]
	},
	{ // Japan
		countryCode: 'JPN',
		callingCode: 81,
		emergencyNumbers: [ ]
	},
	{ // Spain
		countryCode: 'ESP',
		callingCode: 34,
		emergencyNumbers: [ ]
	}
];
// vim:ts=2 sw=2



// WEBPACK FOOTER //
// ./src/constants/EmergencyNumbers.js